// extracted by mini-css-extract-plugin
export default {"wrapper":"SpecImage_wrapper__Ge-7F","title":"SpecImage_title__n8zIW"};